import React from 'react';
import { useEditorProps, useFocusIdx } from '@bay-email/editor';
import { AttributesPanelWrapper } from '@extensions/AttributePanel/components/attributes/AttributesPanelWrapper';
import { BackgroundColor } from '@extensions/AttributePanel/components/attributes/BackgroundColor';
import { FontFamily } from '@extensions/AttributePanel/components/attributes/FontFamily';
import { Padding } from '@extensions/AttributePanel/components/attributes/Padding';
import {
  ImageUploaderField,
  InputWithUnitField,
  RadioGroupField,
  SelectField,
  TextField,
} from '@extensions/components/Form';
import { Collapse, Grid, Space } from '@arco-design/web-react';
import { ClassName } from '../../attributes/ClassName';
import { CollapseWrapper } from '../../attributes/CollapseWrapper';

const positionOptions = [
  {
    value: 'left',
    get label() {
      return t('Left');
    },
  },
  {
    value: 'right',
    get label() {
      return t('Right');
    },
  },
];

const alignOptions = [
  {
    value: 'top',
    get label() {
      return t('Top');
    },
  },
  {
    value: 'middle',
    get label() {
      return t('Middle');
    },
  },
  {
    value: 'bottom',
    get label() {
      return t('Bottom');
    },
  },
];

export function Accordion() {
  const { focusIdx } = useFocusIdx();
  const { onUploadImage } = useEditorProps();

  return (
    <CollapseWrapper defaultActiveKey={['0', '4']} style={{ padding: 0 }}>
        <Collapse.Item
          name='0'
          header={t('Setting')}
        >
          <div className="px-2 py-3">
            <BackgroundColor />
            <FontFamily />
            <Padding />
            <InputWithUnitField
              label={t('Icon width')}
              name={`${focusIdx}.attributes.icon-width`}
            />
            <InputWithUnitField
              label={t('Icon height')}
              name={`${focusIdx}.attributes.icon-height`}
            />
            <ImageUploaderField
              label={t('Unwrapped icon')}
              name={`${focusIdx}.attributes.icon-unwrapped-url`}
              //helpText={t('The image suffix should be .jpg, jpeg, png, gif, etc. Otherwise, the picture may not be displayed normally.')}
              uploadHandler={onUploadImage}
            />
            <ImageUploaderField
              label={t('Wrapped icon')}
              name={`${focusIdx}.attributes.icon-wrapped-url`}
              uploadHandler={onUploadImage}
            />
            <RadioGroupField
              label={t('Icon position')}
              name={`${focusIdx}.attributes.icon-position`}
              options={positionOptions}
            />
            <SelectField
              style={{ width: 120 }}
              label={t('Icon align')}
              name={`${focusIdx}.attributes.icon-align`}
              options={alignOptions}
            />
            <TextField
              label={t('Border')}
              name={`${focusIdx}.attributes.border`}
            />
          </div>
        </Collapse.Item>
        <Collapse.Item
          name='4'
          header={t('Extra')}
        >
          <div className="px-2 py-3">
            <ClassName />
          </div>
        </Collapse.Item>
      </CollapseWrapper>
  );
}
